import { render } from "./Header.vue?vue&type=template&id=3095018e"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rogerkirton/Documents/Development/Soca Islands Repos/app-soca-islands/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__